import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { connect, useSelector } from "react-redux";
import { fetchData } from "../../Store/Actions/LoginAction";
import Select from "react-select";
import { Col, Label, Row } from "reactstrap";
import { Redirect, useHistory } from "react-router-dom/cjs/react-router-dom";
import LoginOtp from "./LoginOtp";
import { Check, Eye, EyeOff, Key, Lock, Mail } from "react-feather";
import { delay } from "../../Helper/ToastDelay";
import loginimg from "../../assets/profile/4794658.jpg";
import reset from "../../assets/profile/reset.jpg";
import PostApiCall from "../../Api/Api";
import moment from "moment";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import OtpInput from "react-otp-input";
import Notiflix, { Notify, Report } from "notiflix";
import { GoogleLogin, GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import jwt from "jsonwebtoken";

const Login = ({ data, errorData, login }) => {
  const [EmailRegex] = useState(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

  const [loginData, setLoginData] = useState({
    usertype: { value: "JobSeeker", label: "Employee" },
    useremail: "",
    userpassword: "",
    userKey: "",
    adminUser: false,
    seekerUser: true,
  });

  const [toggleModal, settoggleModal] = useState(false);
  const [forgotPassData, setForgotPassData] = useState({
    email: "",
    pass: "",
    confirmPass: "",
  });
  const [OtpEntered, setOtpEntered] = useState("");
  const [otpToggle, setOtpToggle] = useState(false);
  const [ShowPassword, setShowPassword] = useState(false);
  const [ShowResetPassword, setShowResetPassword] = useState(false);
  const [ShowConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showResendButton, setShowResendButton] = useState(false);
  const [otpError, setOtpError] = useState(false);

  const history = useHistory();

  const user = useSelector((state) => state.login);
  const [timer, setTimer] = useState(60);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    let interval = null;
    if (otpToggle && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setShowResendButton(true);
    }
    return () => clearInterval(interval);
  }, [otpToggle, timer]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const verifyHandler = () => {
    const isValid = validateEmployeeForm();

    if (isValid) {
      Notiflix.Loading.standard();
      PostApiCall.postRequest(
        {
          name: loginData.useremail,
          updatedat: moment().format("MMM DD, YYYY h:mm A"),
        },
        "GenerateOTP"
      )
        .then((result) => {
          // Handle the response from the verification API
          if (!result.ok) {
            throw new Error("Failed to fetch data");
          }
          Notiflix.Loading.remove();
          history.push("/verifyemail", {
            name: loginData.useremail,
            password: loginData.userpassword,
          });
          toast.success("OTP has been sent to your email", {
            autoClose: delay,
            toastId: 1,
          });

          // window.location.reload();
        })
        .catch((error) => {
          Notiflix.Loading.remove();
          console.error("Error verifying email:", error);
        });
    }
  };

  const onLoginClicked = async () => {
    if (user?.verify === true) {
      verifyHandler();
      return;
    }
    let valid;
    if (loginData.adminUser === true) {
      valid = validateAdminForm();
    } else {
      valid = validateEmployeeForm();
    }

    if (valid) {
      const temp = {
        email: loginData.useremail,
        password: loginData.userpassword,
        isauth: false,
      };

      let endPoint = "";
      if (window.location.pathname !== "/login") {
        temp.key = loginData.userKey;
        endPoint = "StaffLoginEmail";
      } else {
        temp.type = "email";
        endPoint = "CheckIfJobUserExists";
      }
      const userExist = await login(temp, "POST", endPoint, history);
      if (userExist) {
        history.push("/");
        //  Notiflix.Loading.init({ svgColor: "#c16d18" });
        // Report.success(
        //   'Success',
        //   'Logged in successfully',
        //   'Continue',
        //   );
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForgotPassData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleLoginInputChange = (field, value) => {
    setLoginData((prevData) => {
      if (field === "usertype") {
        if (value.value === "admin") {
          return {
            ...prevData,
            [field]: value,
            adminUser: true,
            seekerUser: false,
          };
        } else {
          return {
            ...prevData,
            [field]: value,
            adminUser: false,
            seekerUser: true,
          };
        }
      } else {
        return {
          ...prevData,
          [field]: value,
        };
      }
    });
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const verifiyOTP = () => {
    if (OtpEntered.length < 6) {
      setOtpError(true);
    } else {
      setOtpError(false);
      PostApiCall.postRequest(
        {
          name: forgotPassData.email,
          otp: OtpEntered,
        },
        "VerifyCandidateEmail"
      )
        .then((resultdes) =>
          resultdes.json().then((obj) => {
            if (resultdes.status === 200 || resultdes.status === 201) {
              // toast.success(obj.data[0].Message, {
              //   autoClose: delay,
              // });
              forgotPasswordHandler();
            } else {
              toast.error(obj.data, {
                autoClose: delay,
                toastId: 1,
              });
            }
          })
        )
        .catch((err) => {
          toast.error(err, {
            autoClose: delay,
            toastId: 1,
          });
        });
    }
  };

  const forgotPasswordHandler = async () => {
    const isValid = validateForgotForm();

    if (isValid) {
      setOtpToggle(true);
      try {
        const res = await PostApiCall.postRequest(
          {
            email: forgotPassData.email,
            password: forgotPassData.pass,
          },
          "JobUserResetPassword"
        );
        const { data } = await res.json();
        if (res.ok) {
          toast.success("Password reset successfully", {
            autoClose: delay,
            toastId: 1,
          });
          settoggleModal(false);
          setForgotPassData({
            email: "",
            pass: "",
            confirmPass: "",
          });
        } else {
          throw new Error(data);
        }
      } catch (error) {
        toast.error(error.message, {
          autoClose: delay,
          toastId: 1,
        });
      }
    }
  };

  const validateForgotForm = () => {
    const newErrors = {};
    if (forgotPassData.email === "") {
      newErrors.email = "Email address is required";
    } else {
      if (!EmailRegex.test(String(forgotPassData.email).toLowerCase())) {
        newErrors.email = "Invalid email address";
      }
    }
    if (!forgotPassData.pass) {
      newErrors.pass = "Password is required";
    }
    if (forgotPassData.pass !== forgotPassData.confirmPass) {
      newErrors.confirmPass = "Passwords do not match";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const validateAdminForm = () => {
    const newErrors = {};

    if (!loginData.userKey) {
      newErrors.userKey = "Unique key is required";
    }
    if (loginData.useremail === "") {
      newErrors.useremail = "Email address is required";
    } else {
      if (!EmailRegex.test(String(loginData.useremail).toLowerCase())) {
        newErrors.useremail = "Invalid email address";
      }
    }

    if (!loginData.userpassword) {
      newErrors.userpassword = "Password is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const validateEmployeeForm = () => {
    const newErrors = {};

    if (loginData.useremail === "") {
      newErrors.useremail = "Email address is required";
    } else {
      if (!EmailRegex.test(String(loginData.useremail).toLowerCase())) {
        newErrors.useremail = "Invalid email address";
      }
    }

    if (!loginData.userpassword) {
      newErrors.userpassword = "Password is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const generateOTPHandler = () => {
    const isValid = validateForgotForm();

    if (isValid) {
      Notiflix.Loading.standard();
      PostApiCall.postRequest(
        {
          name: forgotPassData.email,
          updatedat: moment().format("MMM DD, YYYY h:mm A"),
        },
        "GenerateOTP"
      )
        .then((result) => {
          // Handle the response from the verification API
          if (!result.ok) {
            throw new Error("Failed to fetch data");
          }
          Notiflix.Loading.remove();
          toast.success("OTP has been sent to your email", {
            autoClose: delay,
            toastId: 1,
          });

          setOtpToggle(true);
          setTimer(60); // Reset timer to 60 seconds
          setShowResendButton(false);
          // window.location.reload();
        })
        .catch((error) => {
          Notiflix.Loading.remove();
          console.error("Error verifying email:", error);
        });
    }
  };


  const GoogleIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="20px"
      height="20px"
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.67 0 6.97 1.41 9.42 3.69L39.66 6.5C35.5 2.85 30.02 0 24 0 14.87 0 7.1 5.29 3.56 12.93l8.4 6.6C13.61 13.59 18.48 9.5 24 9.5z"
      />
      <path
        fill="#34A853"
        d="M46.13 24.5c0-1.5-.13-2.95-.37-4.34H24v8.19h12.45c-.53 2.76-2.13 5.1-4.58 6.65v5.38h7.41c4.33-4 6.85-9.93 6.85-15.88z"
      />
      <path
        fill="#4A90E2"
        d="M11.96 28.45c-.57-1.32-.9-2.74-.9-4.26s.33-2.94.91-4.26l-8.41-6.6C1.2 16.77 0 20.25 0 24s1.2 7.23 3.56 10.41l8.4-6.6z"
      />
      <path
        fill="#FBBC05"
        d="M24 48c6.02 0 11.5-2.05 15.31-5.56l-7.4-5.38c-2.11 1.41-4.79 2.24-7.91 2.24-5.52 0-10.38-4.09-12.04-9.51l-8.4 6.6C7.1 42.72 14.87 48 24 48z"
      />
      <path fill="none" d="M0 0h48v48H0z" />
    </svg>
  );
  const GoogleLoginButton = () => {
    const handleGoogleLogin = useGoogleLogin({
      onSuccess: async (response) => {
        try {
          // Fetch user info using the access token
          const userInfoResponse = await fetch(
            'https://www.googleapis.com/oauth2/v3/userinfo',
            {
              headers: {
                Authorization: `Bearer ${response.access_token}`,
              },
            }
          );
          if (!userInfoResponse.ok) {
            throw new Error('Failed to fetch user info');
          }
          const userInfo = await userInfoResponse.json();
          const userData = {
            email: userInfo.email,
            isauth: true,
            type:"email"
          };
          const userExist = await login(
            userData,
            "POST",
            "CheckIfJobUserExists",
            history
          );
          
          // Example of accessing user details
          if (userExist) {
            // toast.success('Log in successfully!');
            history.push("/");
            //  Notiflix.Loading.init({ svgColor: "#c16d18" });
            // Report.success(
            //   'Success',
            //   'Logged in successfully',
            //   'Continue',
            //   );
          }
          
        
        } catch (error) {
          console.error('Error fetching user info:', error);
          toast.error('Failed to fetch user information');
        }
      },
      onError: (error) => {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      },
    });
  
    return (
      <button
        className="d-flex align-items-center justify-content-center w-100 py-2 bg-white"
        style={{
          borderRadius: 10,
          border: "1px solid #ccc",
          cursor: "pointer",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={handleGoogleLogin} // Opens Google login popup
      >
        <GoogleIcon />
        <p className="ml-2" style={{ color: "#595959", fontWeight: "500", margin: 0 }}>
          Sign in with Google
        </p>
      </button>
    );
  };
  

  return (
    <div
      className="bg-light d-flex justify-content-center align-items-center mt-5"
      style={{ height: "100vh" }}
    >
      <Row className="d-flex justify-content-center shadow rounded  bg-white ">
        {user?.verify === true ? (
          <Col className="page-login-form px-3 py-5">
            <div
              className=" p-4"
              style={{
                maxWidth: "500px",
                margin: "auto",
                borderRadius: "15px",
              }}
            >
              <div className="text-center mb-4">
                <span
                  className="rounded-circle p-3"
                  style={{
                    border: "3px solid orange",
                    // backgroundColor: "#eaffea",
                  }}
                >
                  <Check color="orange" size={30} />
                </span>
              </div>

              <h3
                className="text-center text-dark mb-3"
                style={{ fontWeight: "bold", fontSize: "1.5rem" }}
              >
                Verify Your Email
              </h3>

              <p
                className="text-center text-secondary mb-4"
                style={{ fontSize: "1rem", lineHeight: "1.5" }}
              >
                Please verify your email address to complete your registration.
                Click the button below to confirm:
                <br />
                <span
                  className="text-dark d-block mt-2"
                  style={{ fontWeight: "bold" }}
                >
                  {loginData.useremail || "Your Email"}
                </span>
              </p>

              <div className="text-center">
                <button
                  onClick={onLoginClicked}
                  className="btn btn-common px-4 py-2"
                  style={{
                    borderRadius: "30px",
                    backgroundColor: "orange",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  Verify Email
                </button>
              </div>
            </div>
          </Col>
        ) : (
          <>
            <Col className="d-none d-md-block  my-auto">
              <img
                src={!toggleModal ? loginimg : reset}
                width={"400px"}
                height={"400px"}
              />
            </Col>

            <Col className="page-login-form p-4">
              {!toggleModal ? (
                <>
                  <h3 style={{ lineHeight: "0px" ,textTransform:'capitalize'}}>
                    {window.location.pathname === "/login"
                      ? "Login"
                      : "Corporate Login"}
                  </h3>

                  <form
                    className="login-form w-100 "
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <div className="form-group">
                      {window.location.pathname !== "/login" ? (
                        <>
                          <div className="input-icon">
                            <i style={{ zIndex: 10 }}>
                              <Key size={15} />
                            </i>

                            <input
                              type="text"
                              value={loginData.userKey}
                              onChange={(e) => {
                                handleLoginInputChange(
                                  "userKey",
                                  e.target.value.toUpperCase()
                                );
                              }}
                              id="sender-email"
                              className="form-control"
                              placeholder="Unique key"
                            />
                          </div>
                          <p
                            style={{
                              width: "100%",
                              marginTop: ".25rem",
                              fontSize: "80%",
                              color: "#dc3545",
                            }}
                          >
                            {errors.userKey}
                          </p>
                          {/* <Mail color="red" size={15}/> */}
                          <div className="input-icon mt-2">
                            <i style={{ zIndex: 10 }}>
                              <Mail size={15} />
                            </i>

                            <input
                              type="text"
                              value={loginData.useremail}
                              onChange={(e) => {
                                handleLoginInputChange(
                                  "useremail",
                                  e.target.value.toLowerCase()
                                );
                              }}
                              id="sender-email"
                              className="form-control"
                              placeholder="Email Address"
                            />
                          </div>
                          <p
                            style={{
                              width: "100%",
                              marginTop: ".25rem",
                              fontSize: "80%",
                              color: "#dc3545",
                            }}
                          >
                            {errors.useremail}
                          </p>
                          {/* {passtoggle && ( */}

                          <div className="input-icon mt-2">
                            <i style={{ zIndex: 10 }}>
                              <Lock size={15} />
                            </i>
                            <input
                              // type="text"
                              type={ShowPassword ? "text" : "password"}
                              value={loginData.userpassword}
                              onChange={(e) => {
                                handleLoginInputChange(
                                  "userpassword",
                                  e.target.value
                                );
                              }}
                              id="sender-email"
                              className="form-control"
                              placeholder="Password"
                            />
                            {ShowPassword ? (
                              <Eye
                                size={15}
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  marginRight: "10px",
                                  marginTop: "15px",
                                }}
                                onClick={() => setShowPassword(!ShowPassword)}
                              />
                            ) : (
                              <EyeOff
                                size={15}
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  marginRight: "10px",
                                  marginTop: "15px",
                                }}
                                onClick={() => setShowPassword(!ShowPassword)}
                              />
                            )}
                          </div>
                          <p
                            style={{
                              width: "100%",
                              marginTop: ".25rem",
                              fontSize: "80%",
                              color: "#dc3545",
                            }}
                          >
                            {errors.userpassword}
                          </p>
                          {/* )} */}
                        </>
                      ) : (
                        <>
                          <div className="input-icon">
                            <i style={{ zIndex: 10 }}>
                              <Mail size={15} />
                            </i>
                            <input
                              type="text"
                              value={loginData.useremail}
                              onChange={(e) => {
                                handleLoginInputChange(
                                  "useremail",
                                  e.target.value.toLowerCase()
                                );
                                // if (NumRegex.test(e.target.value)) {
                                //   if (e.target.value.length <= 10) {
                                //     setIsMobile(true);
                                //   }
                                // } else if (e.target.value === "") {
                                //   setIsMobile(true);
                                // } else {
                                //   setIsMobile(false);
                                //   setPasstoggle(true);
                                // }
                              }}
                              id="sender-email"
                              className="form-control"
                              // placeholder="Mobile/Email"
                              placeholder="Email Address"
                              // style={{ textTransform: "lowercase" }}
                            />
                          </div>
                          <p
                            style={{
                              width: "100%",
                              marginTop: ".25rem",
                              fontSize: "80%",
                              color: "#dc3545",
                            }}
                          >
                            {errors.useremail}
                          </p>
                          {/* {passtoggle && ( */}
                          <div className="input-icon mt-2 d-flex">
                            <i style={{ zIndex: 10 }}>
                              <Lock size={15} />
                            </i>
                            <input
                              type={ShowPassword ? "text" : "password"}
                              value={loginData.userpassword}
                              onChange={(e) => {
                                handleLoginInputChange(
                                  "userpassword",
                                  e.target.value
                                );
                              }}
                              id="sender-email"
                              className="form-control"
                              placeholder="Password"
                            />
                            {ShowPassword ? (
                              <Eye
                                size={15}
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  marginRight: "10px",
                                  marginTop: "15px",
                                }}
                                onClick={() => setShowPassword(!ShowPassword)}
                              />
                            ) : (
                              <EyeOff
                                size={15}
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  top: 0,
                                  marginRight: "10px",
                                  marginTop: "15px",
                                }}
                                onClick={() => setShowPassword(!ShowPassword)}
                              />
                            )}
                          </div>
                          <p
                            style={{
                              width: "100%",
                              marginTop: ".25rem",
                              fontSize: "80%",
                              color: "#dc3545",
                            }}
                          >
                            {errors.userpassword}
                          </p>
                          {/* )} */}
                        </>
                      )}
                    </div>
                    <button
                      onClick={onLoginClicked}
                      className="btn btn-common log-btn mb-0"
                      style={{ borderRadius: 10 }}
                    >
                      Submit
                    </button>
                  </form>

                  <>
                    {window.location.pathname === "/login" && (
                      <>
                        <p
                          style={{
                            display: "flex",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                          className="my-2"
                        >
                          <hr
                            style={{
                              flex: 1,
                              border: "none",
                              borderTop: "1px solid #ccc",
                              margin: "0 10px",
                            }}
                          />
                          <Label style={{ fontSize: "11px" }}>Or</Label>
                          <hr
                            style={{
                              flex: 1,
                              border: "none",
                              borderTop: "1px solid #ccc",
                              margin: "0 10px",
                            }}
                          />
                        </p>

                        <GoogleOAuthProvider
                          clientId={process.env.REACT_APP_CLIENT_ID}
                        >
                          {/* <GoogleLogin
                            text="signin_with"
                            onSuccess={handleGoogleLoginSuccess}
                            onError={handleGoogleLoginFailure}
                          /> */}
                          <GoogleLoginButton/>
                        </GoogleOAuthProvider>
                      </>
                    )}
                  </>
                  {
                        window.location.pathname === "/login" && 
                     
                  <ul className="form-links">
                    <li className="text-center">
                      <div style={{ fontSize: "12px" }} className="mt-2">
                        Don't have an account?{" "}
                        <span
                          style={{ cursor: "pointer" }}
                          className="baseTextColor"
                          onClick={() => history.push("/register")}
                        >
                          Sign Up
                        </span>
                      </div>
                     
                       <div
                        style={{ cursor: "pointer", fontSize: "13px"}}
                        className="baseTextColor"
                        onClick={() => settoggleModal(true)}
                      >
                        Forgot Password
                      </div>
                    </li>
                  </ul>
                      }
                </>
              ) : (
                <>
                  <h3 style={{textTransform:'capitalize'}}>Forgot Password</h3>
                  <form
                    className="login-form"
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <div className="form-group">
                      <div
                        className="input-icon"
                        style={{ borderRadius: 10, zIndex: 20 }}
                      >
                        {!otpToggle ? (
                          <>
                            <div className="input-icon mt-2">
                              <i style={{ zIndex: 10 }}>
                                <Mail size={15} />
                              </i>

                              <input
                                type="text"
                                value={forgotPassData.email}
                                onChange={handleInputChange}
                                id="sender-email"
                                className="form-control"
                                name="email"
                                placeholder="Email Address"
                              />
                            </div>
                            <p
                              style={{
                                width: "100%",
                                marginTop: ".25rem",
                                fontSize: "80%",
                                color: "#dc3545",
                              }}
                            >
                              {errors.email}
                            </p>
                            <div className="input-icon mt-2">
                              <i style={{ zIndex: 10 }}>
                                <Lock size={15} />
                              </i>
                              <input
                                type={ShowResetPassword ? "text" : "password"}
                                value={forgotPassData.pass}
                                onChange={handleInputChange}
                                id="sender-email"
                                name="pass"
                                className="form-control"
                                placeholder="New Password"
                              />
                              {ShowResetPassword ? (
                                <Eye
                                  size={15}
                                  style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    marginRight: "10px",
                                    marginTop: "15px",
                                  }}
                                  onClick={() =>
                                    setShowResetPassword(!ShowResetPassword)
                                  }
                                />
                              ) : (
                                <EyeOff
                                  size={15}
                                  style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    marginRight: "10px",
                                    marginTop: "15px",
                                  }}
                                  onClick={() =>
                                    setShowResetPassword(!ShowResetPassword)
                                  }
                                />
                              )}
                            </div>
                            <p
                              style={{
                                width: "100%",
                                marginTop: ".25rem",
                                fontSize: "80%",
                                color: "#dc3545",
                              }}
                            >
                              {errors.pass}
                            </p>

                            <div className="input-icon mt-2">
                              <i style={{ zIndex: 10 }}>
                                <Lock size={15} />
                              </i>
                              <input
                                type={ShowConfirmPassword ? "text" : "password"}
                                name="confirmPass"
                                value={forgotPassData.confirmPass}
                                onChange={handleInputChange}
                                id="sender-email"
                                className="form-control"
                                placeholder="Confirm Password"
                              />
                              {ShowConfirmPassword ? (
                                <Eye
                                  size={15}
                                  style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    marginRight: "10px",
                                    marginTop: "15px",
                                  }}
                                  onClick={() =>
                                    setShowConfirmPassword(!ShowConfirmPassword)
                                  }
                                />
                              ) : (
                                <EyeOff
                                  size={15}
                                  style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    marginRight: "10px",
                                    marginTop: "15px",
                                  }}
                                  onClick={() =>
                                    setShowConfirmPassword(!ShowConfirmPassword)
                                  }
                                />
                              )}
                            </div>
                            <p
                              style={{
                                width: "100%",
                                marginTop: ".25rem",
                                fontSize: "80%",
                                color: "#dc3545",
                              }}
                            >
                              {errors.confirmPass}
                            </p>
                          </>
                        ) : (
                          <>
                            <p
                              className="text-center"
                              style={{
                                fontSize: "13px",
                                textTransform: "initial",
                              }}
                            >
                              {forgotPassData?.email && (
                                <span>
                                  We have sent a code to{" "}
                                  <b> {forgotPassData?.email}</b>
                                </span>
                              )}
                            </p>
                            <div className="text-center my-2 text-dark">
                              {" "}
                              Please check your email
                            </div>

                            <div className="form-group otp-login my-4">
                              <OtpInput
                                value={OtpEntered}
                                onChange={(e) => setOtpEntered(e)}
                                numInputs={6}
                                isInputNum={true}
                                separator={<span>&nbsp;&nbsp;&nbsp;</span>}
                              />
                            </div>
                            {otpError && (
                              <div className="text-center text-danger">
                                Invalid Input
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <button
                      style={{ borderRadius: 10 }}
                      onClick={otpToggle ? verifiyOTP : generateOTPHandler}
                      className="btn btn-common log-btn"
                    >
                      {otpToggle ? "submit" : "Send OTP"}
                    </button>
                  </form>

                  {otpToggle && showResendButton && (
                    <div
                      style={{ cursor: "pointer" }}
                      className="baseTextColor text-center"
                      onClick={generateOTPHandler}
                    >
                      Resend OTP
                    </div>
                  )}
                  {otpToggle && !showResendButton && (
                    <div className=" text-center">
                      Resend OTP in{" "}
                      <span
                        className="baseTextColor "
                        style={{ fontWeight: "bold" }}
                      >
                        {timer}s
                      </span>
                    </div>
                  )}
                  <div
                    style={{ cursor: "pointer" }}
                    className="baseTextColor text-center"
                    onClick={() => {
                      settoggleModal(false);
                      setOtpToggle(false);
                      setForgotPassData({
                        email: "",
                        pass: "",
                        confirmPass: "",
                      });
                    }}
                  >
                    Back to Login
                  </div>
                </>
              )}
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.login?.data,
    // errorData: state.login.error,
  };
};

const mapDispatchToProps = (dispatch) => ({
  login: (payload, method, url) => {
    return dispatch(fetchData(payload, method, url));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
